import Immutable                  from 'immutable';
import _                          from 'lodash';
import { PRICE_SELECTED, QUOTED } from 'pu-data/QuoteSteps';
import flexParameters             from '../data/DefaultFlexParameters';
import rigidFlexParameters        from '../data/DefaultRigidFlexParameters';
import { numberLayer as numberLayerRidigFlex } from 'pu-data/SelectOptions';

const state = {
};

const copyParameter = [
  'supplier_selected',
  'row_selected',
  'column_selected',
  'product_quote_number',
];

if (Spree.quote) {
  state.quote = Spree.quote;
}

if (Spree.quote_parameters) {
  state.parameters = Spree.quote_parameters;

  _.mapKeys(Spree.quote_parameters, (value, key) => {
    // copy quote parameters to flex
    if (flexParameters[key] !== undefined) {
      flexParameters[key] = value;
    }
    // copy quote parameters to rigid flex
    if (rigidFlexParameters[key] !== undefined) {
      if (key === 'number_of_layers') {
        if (_.find(numberLayerRidigFlex, el => el.value === value)) {
          // copy number of layers value only if available in flex list
          rigidFlexParameters[key] = value;
        }
      } else {
        rigidFlexParameters[key] = value;
      }
    }
  });

  _.forEach(copyParameter, (key) => {
    flexParameters[key] = Spree.quote_parameters[key];
    rigidFlexParameters[key] = Spree.quote_parameters[key];
  });

  state.flexParameters = flexParameters;
  state.rigidFlexParameters = rigidFlexParameters;

  if (Spree.quote_parameters.supplier_selected) {
    state.quoteStep = PRICE_SELECTED;
  } else {
    state.quoteStep = QUOTED;
  }
}

export default Immutable.fromJS(state);
